import React from 'react';
import { Box } from '@chakra-ui/react';
import { StaticImage } from 'gatsby-plugin-image';
import SectionTitle from '../../components/shared/SectionTitle';

const TransformPlanFeatures = () => (
  <Box
    maxW="7xl"
    mx="auto"
    textAlign="center"
    bg="rgba(249,252,255,.8)"
    pt="20"
  >
    <SectionTitle
      title="Transform Plan Features"
      subTitle="Configured to match your unique process and pricing."
    />
    <StaticImage
      src="../../images/transform-plan-diagram.webp"
      alt="Transform plan features"
    />
  </Box>
);

export default TransformPlanFeatures;
